module.exports = __webpack_public_path__ + "tables/media/settings.3b1fba2d.svg";